module.exports = __webpack_public_path__ + "static/fasilkom-e6db25dd0300a77766dc10eeb8075808.png";